(() => {
 'use strict';
 if(window.WotfHomeReadingPlans){window.WotfHomeReadingPlans.init(document);return;}
 const instances=new Map(),mobile=matchMedia('(max-width:768px)');
 const storageKey='wotf.home-reading-depth';
 let frame=0;
 function updateOverlay(){
  frame=0;
  const height=visualViewport?.height||innerHeight;
  const inView=mobile.matches&&[...instances.keys()].some(root=>{const r=root.getBoundingClientRect();return r.width>0&&r.top<height&&r.bottom>80;});
  document.body.toggleAttribute('data-hpr-mobile-in-view',inView);
 }
 function scheduleOverlay(){if(!frame)frame=requestAnimationFrame(updateOverlay);}
 function initRoot(root){
  if(instances.has(root))return;
  const lifecycle=new AbortController(),signal=lifecycle.signal;
  const buttons=[...root.querySelectorAll('[data-hpr-choice]')],panels=[...root.querySelectorAll('.hpr-card[data-plan-key]')],tablist=root.querySelector('[data-hpr-tablist]');
  if(buttons.length!==3||panels.length!==3)return;
  const keys=buttons.map(b=>b.dataset.hprChoice);
  let selected=keys.includes(root.dataset.defaultPlan)?root.dataset.defaultPlan:'focused';
  try{const previous=localStorage.getItem(storageKey);if(keys.includes(previous))selected=previous;}catch{}
  function sync(){
   if(mobile.matches)tablist.setAttribute('role','tablist');else tablist.removeAttribute('role');
   tablist.setAttribute('aria-label','Choose your reading plan');
   buttons.forEach(button=>{
    const active=button.dataset.hprChoice===selected;
    if(mobile.matches){button.setAttribute('role','tab');button.setAttribute('aria-selected',String(active));button.tabIndex=active?0:-1;}
    else{button.removeAttribute('role');button.removeAttribute('aria-selected');button.removeAttribute('tabindex');}
   });
   panels.forEach(panel=>{
    const active=panel.dataset.planKey===selected;
    panel.hidden=mobile.matches&&!active;
    if(mobile.matches){panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',buttons.find(b=>b.dataset.hprChoice===panel.dataset.planKey).id);}
    else{panel.removeAttribute('role');panel.removeAttribute('aria-labelledby');}
   });
   scheduleOverlay();
  }
  function choose(key){
   if(!keys.includes(key))return;
   selected=key;
   try{localStorage.setItem(storageKey,key);}catch{}
   sync();
  }
  root.classList.add('hpr-enhanced');
  root.addEventListener('click',event=>{const button=event.target.closest('[data-hpr-choice]');if(button&&root.contains(button))choose(button.dataset.hprChoice);},{signal});
  tablist.addEventListener('keydown',event=>{
   const current=buttons.indexOf(event.target);if(current<0)return;
   let next=current;
   if(event.key==='ArrowRight')next=(current+1)%buttons.length;
   else if(event.key==='ArrowLeft')next=(current+buttons.length-1)%buttons.length;
   else if(event.key==='Home')next=0;
   else if(event.key==='End')next=buttons.length-1;
   else return;
   event.preventDefault();choose(buttons[next].dataset.hprChoice);buttons[next].focus({preventScroll:true});
  },{signal});
  mobile.addEventListener('change',sync,{signal});
  const observer=new ResizeObserver(scheduleOverlay);observer.observe(root);
  const intersection=new IntersectionObserver(scheduleOverlay);intersection.observe(root);
  instances.set(root,()=>{lifecycle.abort();observer.disconnect();intersection.disconnect();instances.delete(root);root.classList.remove('hpr-enhanced');panels.forEach(p=>{p.hidden=false;p.removeAttribute('role');p.removeAttribute('aria-labelledby');});scheduleOverlay();});
  sync();
 }
 function init(scope){if(scope.matches?.('[data-home-reading-plans]'))initRoot(scope);scope.querySelectorAll?.('[data-home-reading-plans]').forEach(initRoot);}
 window.WotfHomeReadingPlans={init};init(document);
 addEventListener('scroll',scheduleOverlay,{passive:true});addEventListener('resize',scheduleOverlay,{passive:true});visualViewport?.addEventListener('resize',scheduleOverlay,{passive:true});
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>{for(const [root,destroy]of instances)if(event.target===root||event.target.contains(root))destroy();});
})();
